import { render, staticRenderFns } from "./solitaire.vue?vue&type=template&id=e68a520c&scoped=true"
import script from "./solitaire.vue?vue&type=script&lang=js"
export * from "./solitaire.vue?vue&type=script&lang=js"
import style0 from "./solitaire.vue?vue&type=style&index=0&id=e68a520c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68a520c",
  null
  
)

export default component.exports